import stylesC from '../../styles/common.module.css';
import CompanyOverviewSection from '../../components/company/CompanyOverviewSection';
import CompanyDirectionSection from '../../components/company/CompanyDirectionSection';
import CompanyHistorySection from '../../components/company/CompanyHistorySection';


export default function CompanyPage() {

    return (
        <main className={`${stylesC.boxShadow} ${stylesC.main}`}>
            <section className={`${stylesC.boxShadow} ${stylesC.section}`}>
                <CompanyOverviewSection />
            </section>
            <section className={`${stylesC.boxShadow} ${stylesC.section}`}>
                <CompanyHistorySection />
            </section>
            <section className={`${stylesC.boxShadow} ${stylesC.section}`}>
                <CompanyDirectionSection />
            </section>
        </main>
    )
}
